// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./ApiEndpoint.bs.js";
import * as BrowserSpec$OrcaPaymentPage from "../BrowserSpec.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./RecoilAtoms.bs.js";
import * as PaymentError$OrcaPaymentPage from "../Types/PaymentError.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./RecoilAtomsV2.bs.js";
import * as PaymentConfirmTypesV2$OrcaPaymentPage from "../Types/PaymentConfirmTypesV2.bs.js";

function intentCall(fetchApi, uri, headers, bodyStr, confirmParam, optLogger, handleUserError, paymentType, fetchMethod, customPodUri, sdkHandleOneClickConfirmPayment, isPaymentSessionOpt, isCallbackUsedVal, redirectionFlags) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var isConfirm = uri.includes("/confirm");
  var handleOpenUrl = function (url) {
    if (isPaymentSession) {
      return Utils$OrcaPaymentPage.replaceRootHref(url, redirectionFlags);
    } else {
      return Utils$OrcaPaymentPage.openUrl(url);
    }
  };
  return Core__Promise.$$catch(fetchApi(uri, bodyStr, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), fetchMethod, undefined, undefined, undefined, undefined).then(function (res) {
                  var url = new URL(confirmParam.return_url);
                  url.searchParams.set("status", "failed");
                  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                          "confirmParams",
                          confirmParam
                        ]]);
                  if (res.ok) {
                    return res.json().then(function (data) {
                                return new Promise((function (resolve, param) {
                                                var intent = PaymentConfirmTypesV2$OrcaPaymentPage.itemToPMMConfirmMapper(Utils$OrcaPaymentPage.getDictFromJson(data));
                                                var paymentMethod;
                                                paymentMethod = "CARD";
                                                var url = new URL(confirmParam.return_url);
                                                url.searchParams.set("status", intent.authenticationDetails.status);
                                                var handleProcessingStatus = function (paymentType, sdkHandleOneClickConfirmPayment) {
                                                  var exit = 0;
                                                  switch (paymentType) {
                                                    case "Card" :
                                                        exit = 2;
                                                        break;
                                                    case "Gpay" :
                                                    case "Applepay" :
                                                    case "Paypal" :
                                                        exit = sdkHandleOneClickConfirmPayment ? 1 : 2;
                                                        break;
                                                    default:
                                                      exit = 1;
                                                  }
                                                  switch (exit) {
                                                    case 1 :
                                                        if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                          Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                          return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                        } else {
                                                          return handleOpenUrl(url.href);
                                                        }
                                                    case 2 :
                                                        if (isPaymentSession) {
                                                          if (confirmParam.redirect === "always") {
                                                            if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                              return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                            } else {
                                                              return handleOpenUrl(url.href);
                                                            }
                                                          } else {
                                                            return resolve(data);
                                                          }
                                                        } else {
                                                          if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                            Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                          } else {
                                                            Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                          }
                                                          return Utils$OrcaPaymentPage.postSubmitResponse(data, url.href);
                                                        }
                                                    
                                                  }
                                                };
                                                if (intent.authenticationDetails.status !== "requires_customer_action") {
                                                  if (intent.authenticationDetails.status !== "") {
                                                    if (intent.authenticationDetails.status === "succeeded") {
                                                      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.authenticationDetails.status, "PAYMENT_SUCCESS", paymentMethod, undefined);
                                                    } else if (intent.authenticationDetails.status === "failed") {
                                                      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.authenticationDetails.status, "PAYMENT_FAILED", paymentMethod, undefined);
                                                    }
                                                    return handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                  } else {
                                                    handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "succeeded", "PAYMENT_SUCCESS", paymentMethod, undefined);
                                                    return url.searchParams.set("status", "succeeded");
                                                  }
                                                }
                                                if (intent.nextAction.type_ === "redirect_to_url") {
                                                  LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "REDIRECTING_USER", paymentMethod, undefined);
                                                  return handleOpenUrl(intent.nextAction.redirectToUrl);
                                                }
                                                if (!isPaymentSession) {
                                                  Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                }
                                                if (uri.includes("force_sync=true")) {
                                                  LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.nextAction.type_, "REDIRECTING_USER", paymentMethod, "ERROR");
                                                  return handleOpenUrl(url.href);
                                                }
                                                var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                resolve(failedSubmitResponse);
                                              })).then(function (prim) {
                                            return Promise.resolve(prim);
                                          });
                              });
                  } else {
                    return Core__Promise.$$catch(res.json().then(function (data) {
                                    return new Promise((function (resolve, param) {
                                                    if (isConfirm) {
                                                      var paymentMethod;
                                                      paymentMethod = paymentType === "Card" ? "CARD" : Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(bodyStr)), "payment_method_type", "");
                                                      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, JSON.stringify(data), "PAYMENT_FAILED", paymentMethod, undefined);
                                                    }
                                                    var dict = Utils$OrcaPaymentPage.getDictFromJson(data);
                                                    var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
                                                    if (!isPaymentSession) {
                                                      Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                      Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                                    }
                                                    if (handleUserError) {
                                                      return handleOpenUrl(url.href);
                                                    }
                                                    var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                                    resolve(failedSubmitResponse);
                                                  })).then(function (prim) {
                                                return Promise.resolve(prim);
                                              });
                                  }), (function (err) {
                                  return new Promise((function (resolve, param) {
                                                  Utils$OrcaPaymentPage.formatException(err);
                                                  if (!isPaymentSession) {
                                                    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                                                  }
                                                  if (handleUserError) {
                                                    return handleOpenUrl(url.href);
                                                  }
                                                  var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                                  resolve(failedSubmitResponse);
                                                })).then(function (prim) {
                                              return Promise.resolve(prim);
                                            });
                                }));
                  }
                }), (function (err) {
                return new Promise((function (resolve, param) {
                                try {
                                  var url = new URL(confirmParam.return_url);
                                  url.searchParams.set("status", "failed");
                                  Utils$OrcaPaymentPage.formatException(err);
                                  if (!isPaymentSession) {
                                    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                                  }
                                  if (handleUserError) {
                                    return handleOpenUrl(url.href);
                                  }
                                  var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                  return resolve(failedSubmitResponse);
                                }
                                catch (exn){
                                  if (!isPaymentSession) {
                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong");
                                  }
                                  var failedSubmitResponse$1 = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                  return resolve(failedSubmitResponse$1);
                                }
                              })).then(function (prim) {
                            return Promise.resolve(prim);
                          });
              }));
}

function fetchPaymentManagementList(pmSessionId, endpoint, param, customPodUri, sdkAuthorization) {
  var headers = [[
      "Authorization",
      sdkAuthorization
    ]];
  var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/list-payment-methods";
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, undefined, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "GET", undefined, undefined, undefined, undefined).then(function (res) {
                  if (res.ok) {
                    return res.json();
                  } else {
                    return res.json().then(function (param) {
                                return Promise.resolve(null);
                              });
                  }
                }), (function (err) {
                var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                console.error("Error ", exceptionMessage);
                return Promise.resolve(null);
              }));
}

function deletePaymentMethodV2(paymentMethodToken, pmSessionId, param, customPodUri, sdkAuthorization) {
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
  var headers = [[
      "Authorization",
      sdkAuthorization
    ]];
  var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId;
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                              "payment_method_token",
                              paymentMethodToken
                            ]])), ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "DELETE", undefined, undefined, undefined, undefined).then(function (resp) {
                  if (resp.ok) {
                    return resp.json();
                  } else {
                    return resp.json().then(function (param) {
                                return Promise.resolve(null);
                              });
                  }
                }), (function (err) {
                var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                console.error("Error ", exceptionMessage);
                return Promise.resolve(null);
              }));
}

function updatePaymentMethod(bodyArr, pmSessionId, param, customPodUri, sdkAuthorization) {
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
  var headers = [[
      "Authorization",
      sdkAuthorization
    ]];
  var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/update-saved-payment-method";
  return Core__Promise.$$catch(Utils$OrcaPaymentPage.fetchApi(uri, JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr)), ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), "PUT", undefined, undefined, undefined, undefined).then(function (resp) {
                  if (resp.ok) {
                    return resp.json();
                  } else {
                    return resp.json().then(function (param) {
                                return Promise.resolve(null);
                              });
                  }
                }), (function (err) {
                var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                console.error("Error ", exceptionMessage);
                return Promise.resolve(null);
              }));
}

function useSaveCard(optLogger, paymentType) {
  var paymentManagementList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var sdkAuthorization = keys.sdkAuthorization;
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var isCallbackUsedVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  return function (handleUserErrorOpt, bodyArr, confirmParam) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var pmSessionId = keys.pmSessionId;
    if (pmSessionId === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
    }
    var headers = [[
        "Authorization",
        Core__Option.getOr(sdkAuthorization, "")
      ]];
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/confirm";
    var returnUrlArr = [[
        "return_url",
        confirmParam.return_url
      ]];
    var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo(), returnUrlArr)));
    var saveCard = function () {
      intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, bodyStr, confirmParam, optLogger, handleUserError, paymentType, "POST", customPodUri, keys.sdkHandleOneClickConfirmPayment, undefined, isCallbackUsedVal, redirectionFlags);
    };
    if (typeof paymentManagementList !== "object" || paymentManagementList.TAG !== "LoadedV2") {
      return ;
    } else {
      return saveCard();
    }
  };
}

function useUpdateCard(optLogger, paymentType) {
  var paymentManagementList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var sdkAuthorization = keys.sdkAuthorization;
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var isCallbackUsedVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  return function (handleUserErrorOpt, bodyArr, confirmParam) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var pmSessionId = keys.pmSessionId;
    if (pmSessionId === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
    }
    var headers = [[
        "Authorization",
        Core__Option.getOr(sdkAuthorization, "")
      ]];
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    var uri = endpoint + "/v1/payment-method-sessions/" + pmSessionId + "/update-saved-payment-method";
    var returnUrlArr = [[
        "return_url",
        confirmParam.return_url
      ]];
    var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo(), returnUrlArr)));
    var updateCard = function () {
      intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, bodyStr, confirmParam, optLogger, handleUserError, paymentType, "PUT", customPodUri, keys.sdkHandleOneClickConfirmPayment, undefined, isCallbackUsedVal, redirectionFlags);
    };
    if (typeof paymentManagementList !== "object" || paymentManagementList.TAG !== "LoadedV2") {
      return ;
    } else {
      return updateCard();
    }
  };
}

export {
  intentCall ,
  fetchPaymentManagementList ,
  deletePaymentMethodV2 ,
  updatePaymentMethod ,
  useSaveCard ,
  useUpdateCard ,
}
/* recoil Not a pure module */
